













































// vendor
import { defineComponent, computed, ref } from "@vue/composition-api";
// local
import { RecentAssets } from "@/components.home/recent-assets";
import { RecentStudies } from "@/components.home/recent-studies";

export default defineComponent({
	components:{
		RecentAssets,
		RecentStudies,
	},
	setup(){
		return {};
	},
});

